/**
 * @generated SignedSource<<b8ebf5f77136bf5c6ddef66e1d55b360>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionTableFragment$data = {
  readonly id: string;
  readonly rows: number;
  readonly schema: any | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionEditFileFragment">;
  readonly " $fragmentType": "DatasetVersionTableFragment";
};
export type DatasetVersionTableFragment$key = {
  readonly " $data"?: DatasetVersionTableFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionTableFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetVersionTableFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "schema",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rows",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatasetVersionEditFileFragment"
    }
  ],
  "type": "DatasetVersion",
  "abstractKey": null
};

(node as any).hash = "79922efbff8f900aa783fac7d61c7224";

export default node;
